import { useTheme } from "@/lib/ThemeContext"
import { Toaster as Sonner } from "sonner"

// Was wired to next-themes' useTheme(), which this app doesn't use (it
// has its own ThemeProvider in @/lib/ThemeContext) -- calling it with no
// matching provider mounted returns undefined, and destructuring `theme`
// off that throws, crashing on render. That also meant this component
// was never actually usable, which is how the whole app ended up with
// its toast.error()/toast.success() calls being silent no-ops: nothing
// ever mounted a working <Toaster/>. See App.jsx.
const Toaster = ({
  ...props
}) => {
  const { isDark } = useTheme()

  return (
    (<Sonner
      theme={isDark ? 'dark' : 'light'}
      className="toaster group"
      toastOptions={{
        classNames: {
          toast:
            "group toast group-[.toaster]:bg-background group-[.toaster]:text-foreground group-[.toaster]:border-border group-[.toaster]:shadow-lg",
          description: "group-[.toast]:text-muted-foreground",
          actionButton:
            "group-[.toast]:bg-primary group-[.toast]:text-primary-foreground",
          cancelButton:
            "group-[.toast]:bg-muted group-[.toast]:text-muted-foreground",
        },
      }}
      {...props} />)
  );
}

export { Toaster }
